<mat-card class="datatables-block" *ngIf="simulation">
    <mat-card-header>
        <mat-card-title>
            <h2>
                3. {{'dashboard.datatables.title.shortLabel' | translate}} <span class="currency">(€)</span>
                <app-tooltip text="{{'dashboard.datatables.title.summary' | translate}}"></app-tooltip>
            </h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <section class="actions">
            <button mat-raised-button color="accent" class="export-btn"
                (click)="onExport()" [disabled]="isGenerating"
                *ngIf="!user.isRestricted">
                <mat-icon aria-label="File">insert_drive_file</mat-icon>
                {{ 'reports.exports.xls.shortLabel' | translate }}
            </button>
            <button mat-raised-button color="accent" class="export-btn"
                (click)="onExport(true)" [disabled]="isGenerating"
                *ngIf="!user.isRestricted">
                <mat-icon aria-label="File">insert_drive_file</mat-icon>
                {{ 'reports.exports.articles.shortLabel' | translate }}
            </button>
            <mat-spinner *ngIf="isGenerating" [diameter]="35" color="accent" ></mat-spinner>

            <a mat-button *ngIf="derogationLink"
                [routerLink]="derogationLink.route">
                <mat-icon aria-label="Derogations">{{ derogationLink.icon }}</mat-icon>
                {{ derogationLink.title | translate }}
            </a>
        </section>


        <!-- Visible on mobile only -->
        <app-datatable-summary [partitions]="simulation.partitions" [kpisByYear]="simulation.kpisByYear" class="years-table"></app-datatable-summary>

        <!-- Visible on desktop only -->
        <mat-tab-group color="accent" class="datatables-tabs" animationDuration="0ms">
            <mat-tab label="{{'dashboard.datatables.byYears.title.shortLabel' | translate}}">
                <app-datatable-summary [partitions]="simulation.partitions" [kpisByYear]="simulation.kpisByYear"></app-datatable-summary>
            </mat-tab>
            <mat-tab label="{{'dashboard.datatables.byPartitions.title.shortLabel' | translate}}">
                <app-datatable-by-partitions
                    [partitions]="simulation.partitions"
                    [kpisByYear]="simulation.kpisByYear"
                    [isParamMode]="false"></app-datatable-by-partitions>
            </mat-tab>
            <mat-tab label="{{'dashboard.datatables.parameters.title.shortLabel' | translate}}">
                <app-datatable-by-partitions
                    [partitions]="simulation.partitions"
                    [showCompletionRate]="simulation.useCompletionRate"
                    [isMJP]="simulation.isMJP"
                    [isParamMode]="true"></app-datatable-by-partitions>
            </mat-tab>
            <mat-tab *ngIf="simulation.schemaM2" label="{{'dashboard.datatables.schemaM2.title.shortLabel' | translate}}">
                <app-bbc-datatable [simulation]="simulation.schemaM2"></app-bbc-datatable>
            </mat-tab>
            <mat-tab *ngIf="isSimuEdited" label="{{'dashboard.datatables.edited.title.shortLabel' | translate}}">
                <app-datatable-edited [partitions]="simulation.partitions" [kpisByYear]="simulation.kpisByYear" [isMJP]="simulation.isMJP"></app-datatable-edited>
            </mat-tab>
        </mat-tab-group>
    </mat-card-content>
</mat-card>
